// The browser reports screen sharing problems as English DOMExceptions, which would otherwise
// be shown to the user verbatim.
const messageByErrorName: Record<string, string> = {
  NotAllowedError: 'Skærmdeling blev ikke tilladt. Du skal vælge en skærm og slå "Del også systemlyd" til for at optage systemlyd.',
  NotFoundError: 'Der blev ikke fundet en skærm, der kan deles.',
  NotReadableError: 'Der kunne ikke oprettes adgang til systemlyden. Luk andre programmer, der bruger lyden, og prøv igen.',
  AbortError: 'Skærmdelingen blev afbrudt. Prøv igen.',
  InvalidStateError: 'Skærmdeling kunne ikke startes. Klik på siden, og prøv igen.',
  NotSupportedError: 'Din browser understøtter ikke deling af systemlyd. Brug Chrome eller Edge.',
};

export const genericSystemAudioMessage = 'Det er ikke muligt at få adgang til systemlyd. Kontroller at du har givet tilladelse til at dele systemlyd.';

export const missingSystemAudioTrackMessage = 'Der blev ikke delt systemlyd. Slå "Del også systemlyd" til i vinduet til skærmdeling, og prøv igen.';

export function getSystemAudioErrorMessage(error: unknown): string {
  const errorName = typeof error === 'object' && error !== null ? (error as { name?: string }).name : undefined;
  return (errorName && messageByErrorName[errorName]) || genericSystemAudioMessage;
}

export function hasSystemAudioTrack(displayStream: MediaStream): boolean {
  return displayStream.getAudioTracks().length > 0;
}

export function stopSharing(displayStream: MediaStream): void {
  displayStream.getTracks().forEach(track => track.stop());
}
